"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("core-js/fn/array/includes");
require("core-js/es6/promise");
exports.omit = function (ks, original) {
    return Object.keys(original)
        .filter(function (k) { return !ks.includes(k); })
        .reduce(function (filtered, k) {
        return Object.assign(original, (_a = {}, _a[k] = original[k], _a));
        var _a;
    }, {});
};
exports.retryTimes = function (n, fn) {
    return new Promise(function (resolve, reject) {
        return retry(n, fn)
            .then(function (result) { return resolve(result); })
            .catch(function (err) { return reject(err); });
    });
};
var retry = function (i, fn) {
    return fn().catch(function (err) {
        if (i <= 0)
            throw err;
        return retry(i - 1, fn);
    });
};
//# sourceMappingURL=utils.js.map